import { getEntity } from '../../../api/accounting';
import { useConvArtifactStore } from './convArtifactStore';

export async function loadEntityDetailForConv(entityId: string) {
  try {
    const entity = await getEntity(entityId);
    useConvArtifactStore.getState().addArtifact({
      messageIndex: -1,
      type: `entity-detail:${entity.entityType}`,
      data: {
        entityType: entity.entityType,
        provider: entity.provider,
        externalId: entity.externalId,
        ...entity.data,
      },
    });
  } catch {
    // Silently fail — matches dashboard's loadEntityDetail behavior.
  }
}
